<template>
  <div class="ei-login" style="width: 100%;">
    <div class="login_body">
      <div :class="{'container':true,' right-panel-active':!isLogin}">
        <!-- 注册 -->
        <div class="container__form container--signup">
          <form action="#" class="form" id="form1">
            <h2 class="form__title">注册账号</h2>
            <input type="text" placeholder="请输入帐号" class="input" v-model="loginInfo.account"/>
            <input type="password" placeholder="请输入密码" class="input" v-model="loginInfo.password"/>
            <button class="btn" @click="register">点击注册</button>
          </form>
        </div>
        <!-- 登录 -->
        <div class="container__form container--signin">
          <form action="#" class="form" id="form2">
            <h2 class="form__title">欢迎登录</h2>
            <input type="text" placeholder="请输入帐号" class="input" v-model="loginInfo.account"/>
            <input type="password" placeholder="请输入密码" class="input" v-model="loginInfo.password"/>
            <a href="#" class="link">忘记密码?</a>
            <button class="btn" @click="login">登录</button>
          </form>
        </div>
        <!-- 叠加部分 -->
        <div class="container__overlay">
          <div class="overlay" :style="{backgroundImage:'url('+bgImgUrl+')'}">
            <div class="overlay__panel overlay--left">
              <button class="btn" id="signIn" @click="isLogin=true">已有账号，直接登录</button>
            </div>
            <div class="overlay__panel overlay--right">
              <button class="btn" id="signUp"  @click="isLogin=false">没有账号，点击注册</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { loginAction, registerAction } from '@/api/reception/login-api'
import {isFailure} from "@/eiuov-utils/axios/response";

export default {
  name: "EiLogin",
  props: {
    bgImgUrl: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isLogin:true,
      loginInfo: {
        account: '',
        password: '',
      }
    }
  },
  methods: {
    login() {
      if (this.loginInfo.account===''){
        this.$message.warning("请输入帐号")
        return
      }
      if (this.loginInfo.password===''){
        this.$message.warning("请输入密码")
        return
      }
      loginAction(this.loginInfo).then((res) => {
        if (isFailure(res)) return
        this.$cookies.set("token", res.data.token)
        this.$router.push("/Home");
      })

    },
    register() {
      if (this.loginInfo.account===''){
        this.$message.warning("请输入帐号")
        return
      }
      if (this.loginInfo.password===''){
        this.$message.warning("请输入密码")
        return
      }
      registerAction(this.loginInfo).then((res) => {
        if (isFailure(res)) return
        this.$cookies.set("token", res.data.token)
        this.$router.push("/Home");
      })
    }
  }
}
</script>

<style scoped lang="scss">
.login_body {
  /* 弹性盒子 垂直居中	 */
  align-items: center;
  /* 	背景固定。即使一个元素拥有滚动机制，背景也不会随着元素的内容滚动。 */
  background-attachment: fixed;
  /* 	图片居中 */
  background-position: center;
  /* 	background-repeat定义背景图像的重复方式，no-repeat背景图像将仅显示一次 */
  background-repeat: no-repeat;
  /* 把背景图片放大到适合元素容器的尺寸	 */
  background-size: cover;
  /* 网格布局	 */
  display: grid;
  /* 设置height:100vh，能够保证元素无论是否有没有内容，高度都等于屏幕高度。	 */
  height: 100vh;
  /* 沿着对齐容器的中心对齐。	 */
  place-items: center;
  font-size: 16px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
  Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}

/* 标题 */
.form__title {
  /* 字体粗细 */
  font-weight: 300;
  margin: 0;
  margin-bottom: 1.25rem;
}

/* 忘记密码字体样式 */
.link {
  color: #333;
  font-size: 0.9rem;
  margin: 1.5rem 0;
  text-decoration: none;
}

/* 主体DIV样式 */
.container {
  background-color: #e9e9e9;
  border-radius: 0.7rem;

  /* 添加阴影效果 */
  box-shadow: 0 0.9rem 1.7rem rgba(0, 0, 0, 0.25),
  0 0.7rem 0.7rem rgba(0, 0, 0, 0.22);

  height: 420px;
  max-width: 758px;
  overflow: hidden;
  position: relative;
  width: 100%;
}

/* 登录、注册框部分 */
.container__form {
  height: 100%;
  position: absolute;
  top: 0;
  transition: all 0.6s ease-in-out;
}

.container--signin {
  left: 0;
  width: 50%;
  z-index: 2;
}

.container.right-panel-active .container--signin {
  transform: translateX(100%);
}

.container--signup {
  left: 0;
  opacity: 0;
  width: 50%;
  z-index: 1;
}

.container.right-panel-active .container--signup {
  animation: show 0.6s;
  opacity: 1;
  transform: translateX(100%);
  z-index: 5;
}

/* 叠加部分样式 */
.container__overlay {
  height: 100%;
  left: 50%;
  overflow: hidden;
  position: absolute;
  top: 0;
  transition: transform 0.6s ease-in-out;
  width: 50%;
  z-index: 100;
}

.container.right-panel-active .container__overlay {
  transform: translateX(-100%);
}

.overlay {
  background-color: #C06444;
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
  left: -100%;
  position: relative;
  transform: translateX(0);
  transition: transform 0.6s ease-in-out;
  width: 200%;
}

.container.right-panel-active .overlay {
  transform: translateX(50%);
}

.overlay__panel {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  position: absolute;
  text-align: center;
  top: 0;
  transform: translateX(0);
  transition: transform 0.6s ease-in-out;
  width: 50%;
}

.overlay--left {
  transform: translateX(-20%);
}

.container.right-panel-active .overlay--left {
  transform: translateX(0);
}

.overlay--right {
  right: 0;
  transform: translateX(0);
}

.container.right-panel-active .overlay--right {
  transform: translateX(20%);
}

/* 按钮设置 */
.btn {
  background-image: linear-gradient(135deg, #E5000D 0%, #570409 90%);
  border-radius: 25px;
  color: #e9e9e9;
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: bold;
  letter-spacing: 0.1rem;
  padding: 0.9rem 4rem;
  text-transform: uppercase;
  transition: transform 80ms ease-in;
}

.form > .btn {
  margin-top: 1.5rem;
}

.btn:active {
  transform: scale(0.95);
}

.btn:focus {
  outline: none;
}

/* 表单样式 */
.form {
  background-color: #e9e9e9;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0 3rem;
  height: 100%;
  text-align: center;
}

.input {
  background-color: #fff;
  border: none;
  padding: 0.9rem 0.9rem;
  margin: 0.5rem 0;
  width: 100%;
}

@keyframes show {
  0%,
  49.99% {
    opacity: 0;
    z-index: 1;
  }

  50%,
  100% {
    opacity: 1;
    z-index: 5;
  }
}
</style>
